import React from 'react';

const ScrollContext = React.createContext({
  isScrolled: false,
  setIsScrolled: () => {},
});

export default ScrollContext;
